import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import CardHeading from "../../UI/Headings/CardHeading";

export function ProviderDetails(props) {
  let { providerDetails, onclick, existingIntakePractices } = props;

  return (
    <DashboardCard2
      Actions={
        <Button2 variant="text" onPress={onclick}>
          Edit
        </Button2>
      }
      data-public="true"
      title="Provider Details"
    >
      <div className="row no-gutters mt-4">
        <div className="col-12 col-lg-6">
          <CardHeading text="Provider Name" className="fs-14 mx-0 mx-md-3" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.name}</p>
        </div>

        <div className="col-12 col-lg-6">
          <CardHeading text="Email Address" className="fs-14 mx-0 mx-md-3" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.email}</p>
        </div>
      </div>

      <div className="row no-gutters mt-4">
        <div className="col-12 col-lg-6">
          <CardHeading text="CP Credentials" className="fs-14 mx-0 mx-md-3" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.cp_credentials}</p>
        </div>

        <div className="col-12 col-lg-6">
          <CardHeading text="NPI Number" className="fs-14 mx-0 mx-md-3" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.npi_number}</p>
        </div>
      </div>

      <div className="row no-gutters mt-4">
        <div className="col-12 col-lg-6">
          <CardHeading text="Mobile" className="fs-14 mx-0 mx-md-3" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.mobile}</p>
        </div>
        <div className="col-12 col-lg-6">
          <CardHeading text="Provider Type" className="fs-14 mx-0 mx-md-3" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.provider_type}</p>
        </div>
      </div>

      {providerDetails.provider_type === "BEHAVIORAL_INTAKE" && (
        <div className="row no-gutters my-4">
          <div className="col-12 col-lg-6">
            <CardHeading text="Intake Coordinator For Practice(s)" className="fs-14 mx-0 mx-md-3" />

            <ul className="fs-14 mx-0 mx-md-3 mb-4">
              {existingIntakePractices &&
                existingIntakePractices.map((intakePractice) => {
                  return (
                    <li key={intakePractice.value || intakePractice.label}>
                      {intakePractice.label}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      )}
    </DashboardCard2>
  );
}
